import { useEffect, useState } from 'react'
import CommonUtil from "./CommonUtil";

/**
 * This function use to set scroll to top
 * Author: Oliver.Nguyen
 * @param {*} initialScrollState 
 */
export const useScrollToTop = (initialScrollState = false) => {
    const [scrollToTop, setScrollToTop] = useState(initialScrollState);
  
    useEffect(() => {
      if (scrollToTop) {
        setScrollToTop(false);
        try {
          CommonUtil.scrollToTop();
        } catch (error) {
          window.scrollTo(0, 0);
        }
      }
    }, [scrollToTop, setScrollToTop]);
    return setScrollToTop;
  };


// WEBPACK FOOTER //
// ./src/app/common/useScrollToTop.js